import { StyledTableCell, StyledTableRow, TableWrapper } from "../../components/ui/table";
import { Chip, TableCell, TableContainer, TableRow, styled } from "@mui/material";
import React from "react";

// Same table look as pages/cronJobs and pages/breefTracking



export const orangeButton = {}; // knapfarver kommer fra temaet
export const outlinedButton = {}; // knapfarver kommer fra temaet

export const LevelChip = ({ level }: { level: string }) => (
  <Chip
    size="small"
    label={level}
    color={level === "error" ? "error" : level === "warn" ? "warning" : "default"}
  />
);

export const formatTime = (value?: string) => (value ? new Date(value).toLocaleString("da-DK") : "");

/** "2026-09-21T14:00" for a datetime-local field -> ISO string for the API */
export const toIso = (value: string) => (value ? new Date(value).toISOString() : "");

export { StyledTableCell, StyledTableRow, TableWrapper };
